const DEFAULT_AUTH_RETURN_PATH = "/profile";

/** Only allow local app paths so auth redirects cannot be used as open redirects. */
export function resolveAuthReturnPath(
  state: unknown,
  fallback = DEFAULT_AUTH_RETURN_PATH
): string {
  if (!state || typeof state !== "object") return fallback;

  const returnTo = (state as { returnTo?: unknown }).returnTo;
  if (
    typeof returnTo !== "string" ||
    !returnTo.startsWith("/") ||
    returnTo.startsWith("//")
  ) {
    return fallback;
  }

  return returnTo;
}
